import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import havi_logo from "../../assets/img/havi_logo.jpg";
import mcd_logo from "../../assets/img/mcd_logo.jpg";
import _alerts from "../../assets/img/phase3/alerts.svg";
import _historical_Insights from "../../assets/img/phase3/insights.svg";
import _workflow from "../../assets/img/phase3/management.svg";
import _closed_Events from "../../assets/img/phase3/closed_events.svg";
import { NavLink } from "react-router-dom";

const CardComponent = ({
  logo,
  topImage,
  btnLink,
  link,
  btnName,
  onClickBtn,
  title,
  description,
  disabled,
  imageClassName = ""
}) => {
  let logo_img;
  let btnComponent;

  if (logo === "havi") {
    logo_img = havi_logo;
  } else if (logo === "mcd") {
    logo_img = mcd_logo;
  } else if (logo === "_alerts") {
    logo_img = _alerts;
  } else if (logo === "_historical_Insights") {
    logo_img = _historical_Insights;
  } else if (logo === "_workflow") {
    logo_img = _workflow;
  } else if (logo === "_closed_Events") {
    logo_img = _closed_Events;
  }

  if (btnLink === "nav") {
    btnComponent = (
      <NavLink to={link} className="nav-link-noheight" activeClassName="active">
        <Button
          className="btn-sm btn-block ext-base ext-btn-rev"
          onClick={!disabled ? onClickBtn : () => {}}
          disabled={disabled}
        >
          {btnName}
        </Button>
      </NavLink>
    );
  } else if (btnLink === "link") {
    btnComponent = (
      <Button className="ext-base ext-btn-rev" href={link} target="_blank">
        Link
      </Button>
    );
  }

  return (
    <Card style={{ height: "100%" }}>
      <Card.Body className="card-body-improved">
        <div>
          <Card.Img className={imageClassName} variant="top" src={topImage} />
        </div>
        <Card.Title style={{ fontSize: "14px", margin: "18px 0" }}>
          {/* {title} */}
        </Card.Title>
        {/* <Card.Text style={{ fontSize: "13px" }}>{description}</Card.Text> */}
        {btnComponent}
      </Card.Body>
    </Card>
  );
};

export default CardComponent;
